import { GET_API } from "../../Functionalities/APIs";
import { fmtDate, fmtDateWithWeekday, rangeLabel } from "../Insights/format";

const TOTALS_URL = "/accounts/settlement/riders/salaries/";

export const totalsQuery = ({ from, to }) => `from=${from}&to=${to}`;

export const fetchSalaryTotals = async (range) => {
  const result = await GET_API("", totalsQuery(range), TOTALS_URL);
  const body = (result && result.data) || {};
  return body.Status === true
    ? { riders: body.riders || [], totals: body.totals || null }
    : { riders: [], totals: null, error: body.Error || "Could not load the submitted salaries" };
};

const SUBMITTED_AT = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "numeric",
  month: "short",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

export const submittedLine = (row) => {
  const who = row.submitted_by || (row.submitters > 1 ? `${row.submitters} people` : "");
  const at = row.last_submitted_at ? SUBMITTED_AT.format(new Date(row.last_submitted_at)) : "";
  return [who, at].filter(Boolean).join(" · ");
};

export const notesLabel = (notes) => {
  if (!notes || notes.length === 0) return "";
  return notes.length === 1 ? notes[0].text : `${notes.length} notes`;
};

export const notesDetail = (notes) => (notes || []).map((note) => `${fmtDate(note.date)}: ${note.text}`).join("\n");

export const periodLabel = (range) => (range.from === range.to ? fmtDateWithWeekday(range.from) : rangeLabel(range));
